import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';


export default function ProductcompositionInfo(){
  const { productcompositionObj} = useSelector((state)=>state.pharmaslice.productcompositionDashboard);
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'white'}}
      >
            
        <Grid item lg={4} xs={6}><FieldView2 label="Product ID"  value={ productcompositionObj.productid!==null && productcompositionObj.productid!==undefined?productcompositionObj.productid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Composition Name"  value={ productcompositionObj.compositionname!==null && productcompositionObj.compositionname!==undefined?productcompositionObj.compositionname:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Composition ID"  value={ productcompositionObj.compositionid!==null && productcompositionObj.compositionid!==undefined?productcompositionObj.compositionid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Quantity"  value={ productcompositionObj.quantity!==null && productcompositionObj.quantity!==undefined?productcompositionObj.quantity:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Business Id"  value={ productcompositionObj.businessid!==null && productcompositionObj.businessid!==undefined?productcompositionObj.businessid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Order Id"  value={ productcompositionObj.orderid!==null && productcompositionObj.orderid!==undefined?productcompositionObj.orderid:'NOT KNONWN' }/></Grid>
      </Grid>
      </Grid>
      </Box>
    )
}